import { Box, Button, Divider, Typography } from "@mui/material"
import CustomDialog from "components/Dialogs/MasterDialog"
import { CommonTexts } from "locale/es"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { deleteAlertAction } from "redux/reducers/alertsReducer"
import { AppColors } from "resources/AppColors"

export function DeleteAlertDialog() {
  const { entityId } = useLocation().state

  const navigate = useNavigate()

  const dispatch = useDispatch()

  function handleOnConfirmDeleteAlert() {
    dispatch(deleteAlertAction(entityId))
    handleShowExitModal()
  };

  function handleShowExitModal() {
    navigate('/alertes')
  }

  return (
    <CustomDialog
      title={"Eliminar Alerta"}
      show={true}
      handleShow={handleShowExitModal}
    >
      <Divider />
      <Box py={2} px={3} sx={{ minWidth: "50%" }}>
        <Typography variant="body">
          Esteu segur que voleu suprimir aquesta alerta?
        </Typography>
      </Box>
      <Divider />
      <Box display="flex" justifyContent="flex-end" p={1}>
        <Button
          data-cy="submit-delete-alert-button"
          style={{ backgroundColor: AppColors.RED }}
          color="primary"
          variant="contained"
          onClick={handleOnConfirmDeleteAlert}
        >
          {CommonTexts.DELETE}
        </Button>
      </Box>
    </CustomDialog>
  )
}
